import React from 'react';

// 確認ポップアップコンポーネント（アカウント削除用カスタマイズバージョン）
export const ConfirmationPopup = ({
  showConfirmationPopup,
  confirmationPopupData,
  closeConfirmationPopup,
  proceedToDetails // 削除処理を実行する関数
}) => {
  if (!showConfirmationPopup || !confirmationPopupData) return null;
  
  return (
    <div className="confirmation-popup-overlay">
      <div className="confirmation-popup-container">
        <div className="confirmation-popup-content">
          <h2 className="confirmation-title">アカウント削除確認</h2>
          
          <div className="confirmation-details">

            <div className="comment-header u-mt-medium">アカウント情報</div>
            <div className="confirmation-files">
              <div className="confirmation-file-item font-large">
                <div className="file-path">ユーザー名: {confirmationPopupData.username}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">アカウント名（メールアドレス）: {confirmationPopupData.accountname}</div>
              </div>
            </div>
            
            <div className="confirmation-comment">
              <div className="comment-header-error">注意事項</div>
              <div className="comment-content comment-content--error">
                このアカウントを削除すると、関連するすべてのデータが削除され、元に戻すことはできません。
                削除してよろしいですか？
              </div>
            </div>
          </div>
          
          <div className="action-buttons c-max-mini c-m-center">
            <button 
              className="button button-secondary button-medium" 
              onClick={closeConfirmationPopup}
            >
              キャンセル
            </button>
            <button 
              className="btn btn-primary button-medium" 
              onClick={proceedToDetails}
            >
              削除する
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};